"use client";
/**
 * AskAIPanel - lazy dynamic export
 *
 * AskAIPanel appears below the fold on all blog posts. Loading it eagerly
 * adds its JS to the initial hydration bundle, increasing TBT on mobile.
 *
 * Using next/dynamic with ssr:false means:
 * - The panel JS chunk is fetched AFTER the main thread is clear
 * - Zero impact on FCP, LCP, or CLS (below the fold)
 * - Direct reduction in Total Blocking Time (TBT) on mobile
 *
 * All 15+ blog post files import from this path unchanged.
 */
import dynamic from "next/dynamic";

const AskAIPanel = dynamic(() => import("./AskAIPanelInner"), {
  ssr: false,
  loading: () => null,
});

export default AskAIPanel;
